'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: {},
    props: ['buffer', 'message'],
    data: function data() {
        return {};
    },
    computed: {},
    methods: {
        urlPreview: function urlPreview(url) {
            _state2.default.$emit('mediaviewer.show', url);
        },
        areWeAnOp: function areWeAnOp() {
            var ourNick = this.buffer.getNetwork().nick;
            return this.buffer.isUserAnOp(ourNick);
        },
        onBan: function onBan(reason) {
            var network = this.buffer.getNetwork();
            network.ircClient.mode(this.buffer.name, '+b', this.message.nick);
        },
        onKick: function onKick(promptedReason) {
            var network = this.buffer.getNetwork();
            var defaultReason = _state2.default.setting('buffers.default_kick_reason');
            var reason = promptedReason || defaultReason;
            network.ircClient.raw('KICK', this.buffer.name, this.message.nick, reason);
        },
        openQuery: function openQuery() {
            var network = this.buffer.getNetwork();
            var buffer = _state2.default.addBuffer(network.id, this.message.nick);
            _state2.default.setActiveBuffer(network.id, buffer.name);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageInfo"]
window._kiwi_exports.components.MessageInfo = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MessageInfo.vue
// module id = 10Te
// module chunks = 1